var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Cell Span")]),_c('Explain'),_c('BodyColspan'),_c('BodyRowspan'),_c('FooterCellSpan'),_c('CustomContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }